import { createSelector } from 'reselect'
import layerShouldRender from '../utility/layerShouldRender'

const getLayersRendered = (state, layerName) => {
  // if (layerName === 'UploadRaster') {
  //   console.log(state.layer.layersRendered)
  // }
  return state.layer.layersRendered
}

const getAuthLayers = state => {
  return state.login.layers
}

const getServiceLayers = state => {
  return state.service.layers
}

const getLayerName = (state, layerName) => {
  return layerName
}

const getAuthId = (state, layerName, authId) => {
  return authId
}

export const makeGetLayerRendered = () => {
  return createSelector(
    [
      getLayersRendered,
      getAuthLayers,
      getServiceLayers,
      getLayerName,
      getAuthId
    ],
    (layersRendered, authLayers, serviceLayers, layerName, authId) => {
      // if (layerName === 'Energir') {
      //   console.log(layerName, layersRendered, authLayers, serviceLayers, authId)
      // }
      const renderLayer = layerShouldRender(
        layerName,
        layersRendered,
        authLayers,
        serviceLayers,
        authId
      )
      if (layerName === 'UploadRaster') {
        if (layersRendered.includes(layerName)) {
          return true
        }
      }
      return renderLayer
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/layerRenderedSelector.js